import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=c3068a28&"
import script from "./navmenu.vue?vue&type=script&lang=js&"
export * from "./navmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports